import styled from '@emotion/styled';

export const StyledCenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
